// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__kVUbJ","savePackageButton":"ClientWallet_savePackageButton__3rBRm"};